import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from './Button';

export default function BasicTextFields({title, setEmail, setPassword, handleAction,}){
	
	
	return(
		<section className="form-user" >
			
			<div className="heading-container">
				<h3>{title} Form: Get Started^^</h3>
			</div>
			
			<Box
				component='form'
				sx={{
					'&>:not(style)':{ mb:2, width:'25ch'},
				}}
				noValidate
				autoComplete="off"
			>
				<TextField id="email" label="Enter the Email"  type="email" variant="outlined" style={{width: '100%'}} onChange={(e) => setEmail(e.target.value)}/>
				<TextField id="password" label="Enter the Password"  type="password" variant="outlined" style={{width: '100%'}} onChange={(e) => setPassword(e.target.value)}/>
			</Box>
			
			<Button title={title} handleAction={handleAction}/>
			
		</section>
	);
}